import { Injectable } from "@angular/core";
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CrudService } from "src/app/core/services/crud.service";
import { fetchAdminProfileData, fetchAdminProfileSuccess, fetchAdminProfileFailure, updateAdminProfileImage, updateAdminProfileImageSuccess, updateAdminProfileImageFailure, updateAdminProfile, updateAdminProfileFailure, updateAdminProfileSuccess, changePassword, changePasswordFailure, changePasswordSuccess } from "./layout-action";
import { MatSnackBar } from "@angular/material/snack-bar";


@Injectable()

export class LayoutEffects {

  constructor(
    private actions$: Actions,
    private CrudService: CrudService,
    private snackBar: MatSnackBar
  ) { }

  fetchAdminProfileData$ = createEffect(() =>
    this.actions$.pipe(
        ofType(fetchAdminProfileData),
        mergeMap(() =>
            this.CrudService.getData('Account/GetMyProfile').pipe(
                map((resp) => {
                    if (resp.successful) {
                        // Map the `result` object to `adminProfiledata`
                        return fetchAdminProfileSuccess({ adminProfiledata: resp.result });
                    } else {
                        // Handle unsuccessful response
                        return fetchAdminProfileFailure({ error: resp.message || 'Unknown error' });
                    }
                }),
                catchError((error) =>
                    of(fetchAdminProfileFailure({ error: error.message || 'Server error' }))
                )
            )
        )
    )
  );

  updateAdminProfileImageEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateAdminProfileImage),
      switchMap((action) =>
        this.CrudService.postData('Account/UpdateProfileImage',action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.open('Profile image updated successfully', '', {
                duration: 3000,
                panelClass: 'success',
              });
            } else {
              this.snackBar.open(result.message, '', {
                duration: 3000,
                panelClass: 'danger',
              });
            }
          }),
          mergeMap((res) => {
            return [
              updateAdminProfileImageSuccess({ payload: res.result }),
              fetchAdminProfileData(),
            ];
          }),
          catchError((error) => {
            return of(updateAdminProfileImageFailure({ error }));
          })
        )
      )
    );
  });

  updateAdminProfileEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateAdminProfile),
      switchMap((action) =>
        this.CrudService.postData('Account/UpdateProfile',action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.open('Profile updated successfully', '', {
                duration: 3000,
                panelClass: 'success',
              });
            } else {
              this.snackBar.open(result.message, '', {
                duration: 3000,
                panelClass: 'danger',
              });
            }
          }),
          mergeMap((res) => {
            return [
              updateAdminProfileSuccess({ payload: res.result }),
              fetchAdminProfileData(),
            ];
          }),
          catchError((error) => {
            return of(updateAdminProfileFailure({ error }));
          })
        )
      )
    );
  });

  changePsswrodEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(changePassword),
      switchMap((action) =>
        this.CrudService.postData('Account/ChangePassword',action.payload).pipe(
          tap((result) => {
            if (result.successful) {
              this.snackBar.open('Password updated successfully', '', {
                duration: 3000,
                panelClass: 'success',
              });
            } else {
              this.snackBar.open(result.message, '', {
                duration: 3000,
                panelClass: 'danger',
              });
            }
          }),
          mergeMap((res) => {
            return [
              changePasswordSuccess({ payload: res.result }),
            ];
          }),
          catchError((error) => {
            return of(changePasswordFailure({ error }));
          })
        )
      )
    );
  });
}
